<template>
  <v-form @submit.prevent="validate()" ref="form">
    <v-snackbar v-model="snackbar.visibility" :timeout="snackbar.timeout" :color="snackbar.color">
      {{ snackbar.text }}
      <v-btn text @click="remove()" v-show="snackbar.confirm">Confirm</v-btn>
      <v-btn text @click="setSnackbar({ ...snackbar, visibility: false })">{{ snackbar.cancelText }}</v-btn>
    </v-snackbar>
    <v-container grid-list-md>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field v-model="category.name" label="Name" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field v-model="category.icon" label="Icon" :append-outer-icon="category.icon" :rules="[rules.required]" />
        </v-col>
        <v-col cols="12">
          <v-combobox v-model="category.subcategories" label="Subcategories" multiple chips deletable-chips />
        </v-col>
        <v-col cols="12">
          <v-btn type="submit" block color="primary">Submit</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import CategoriesService from '@/services/CategoriesService'
import rules from '@/mixins/rules'

export default {
  name: 'CategoryForm',
  mixins: [rules],
  computed: {
    ...mapGetters([
      'categories',
      'snackbar'
    ]),
    category () {
      const category = this.categories.filter((category) => category._id === this.$route.params.id)

      return (category.length) ? category[0] : { subcategories: [] }
    }
  },
  methods: {
    ...mapMutations([
      'setSnackbar'
    ]),
    async validate () {
      if (this.$refs.form.validate()) {
        try {
          let response
          if (this.$route.params.id) {
            response = await CategoriesService.updateCategory(this.category)
          } else {
            response = await CategoriesService.addCategory(this.category)
          }

          this.setSnackbar({
            ...this.snackbar,
            text: response.data.message,
            color: 'success',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          this.$router.push('/admin/categories')
        } catch (e) {
          if (e.response.status === 403) {
            this.$router.push('/login')
          }

          this.setSnackbar({
            ...this.snackbar,
            text: 'Unable to modify category',
            color: 'error',
            cancelText: 'Close',
            confirm: false,
            visibility: true
          })

          console.error(e)
        }
      }
    }
  }
}
</script>
